import { Configurator, useConfigurio } from "@rromikas/configurio";
import { FunctionComponent } from "react";
import Preview from "./preview";

interface PreviewRootProps {
  configurator: Configurator;
}

const PreviewRoot: FunctionComponent<PreviewRootProps> = ({ configurator }) => {
  const props = useConfigurio(configurator);
  return <Preview {...props} />;
};

export default PreviewRoot;
